import {useCallback} from 'react';

export const useCharacterRange = (props: {
  text: string;
  min?: number;
  max?: number;
  noticeBuffer?: number;
}): {
  count: () => number;
  available: () => number;
  total: () => number;
  isUnder: () => boolean;
  isOver: () => boolean;
  showBuffer: () => boolean;
} => {
  const {text, min = 0, max = text.length, noticeBuffer = 0} = props;

  const count = useCallback(() => text.length, [text]);
  const available = useCallback(() => max - text.length, [max, text]);
  const total = useCallback(() => max, [max]);
  const isUnder = useCallback(() => min > text.length, [min, text]);
  const isOver = useCallback(() => max < text.length, [max, text]);
  const showBuffer = useCallback(() => text.length > max - noticeBuffer, [text, max, noticeBuffer]);

  return {
    count,
    available,
    total,
    isUnder,
    isOver,
    showBuffer,
  };
};
